<template>
	<div><iframe id="iframe" src="https://www.yuque.com/chengyitongxin/exu76c/dz6vga00a5mksf4m"
			style="height: 800px; width: 100%;" frameborder="0"></iframe></div>
</template>
<script>
	import {
		getFindOperationManual
	} from '../../api/operationManual.js';

	export default {
		name: 'operationManual2',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				tableData: [],
				iframeURL: ''
			};
		},
		created() {
			this.getData();
		},
		methods: {

			getData() {
				this.loading = true;
				getFindOperationManual().then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			toURL(e) {
				this.urlVisible = true;
				this.iframeURL = e;
			}
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	/* a:hover{background: #66b1ff} */
	.handle-select {
		width: 240px;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.mr100 {
		position: absolute;
		right: 100px;
	}

	.myRight {
		position: absolute;
		right: 10px;
		bottom: 10px;
	}

	.handle-input {
		width: 200px;
		display: inline-block;
	}
</style>